import { render, staticRenderFns } from "./EmployeeComponent.vue?vue&type=template&id=b69698e0"
import script from "./EmployeeComponent.vue?vue&type=script&lang=js"
export * from "./EmployeeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports